import type {
  ExtendedConstraints,
  CapabilityConfig,
  Message,
} from '../../types';
import { hasOnlyKeysFromSet } from '../../utils';

export const id = 'alert-banner';

export enum Events {
  CustomEvent = 'alert-banner:custom-event',
}

export type CustomEventPayload = unknown;

export enum Actions {
  Add = 'alert-banner:add',
  Dismiss = 'alert-banner:dismiss',
}

export enum Mode {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export type AddPayload = {
  id: string;
  title?: string;
  subtitle?: string;
  bannerMode?: Mode;
  isBannerUrgent?: boolean;
  actionText?: string;
  isCloseable?: boolean;
  href?: string;
  callback?: Message;
  dismissCallback?: Message;
};

export type DismissPayload = {
  id: string;
};

export type Config = CapabilityConfig & {
  type: typeof id;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  actionPayloadTuple:
    | [Actions.Add, AddPayload]
    | [Actions.Dismiss, DismissPayload];
  eventPayloadTuple: [Events.CustomEvent, CustomEventPayload];
  eventHandlerTuple:
    | [Events.CustomEvent, (payload: CustomEventPayload) => void];
}>;

const VALID_CONFIG_KEYS = ['type'] as const;
export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
